import React, { useContext } from "react";
import { MyContext } from "../../Context/MyContext";
import { resolveImage } from "../../../Utils/imageUtils";
import "./AppPromo.css";

export default function AppPromo() {
  const { appPromo } = useContext(MyContext);
  const storeButtons = appPromo?.storeButtons ?? [];

  if (!appPromo?.title && !storeButtons.length) return null;

  return (
    <section className="app-promo">
      <div className="promo-container">

        {/* LEFT CONTENT */}
        <div className="promo-left">
          <h2>{appPromo.title}</h2>
          <p className="subtitle">{appPromo.subtitle}</p>
          <p className="description">{appPromo.description}</p>

          <div className="store-buttons">
            {storeButtons.map((store) => (
              <a
                key={store.id ?? store.legacyId ?? store.name}
                href={store.link}
                target="_blank"
                rel="noreferrer"
                className="button_logo"
              >
                <img src={resolveImage(store.image)} alt={store.name} />
                <div>
                    <h5>Download on the</h5>
                    <p>{store.name}</p>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="promo-right">
          <img src={resolveImage(appPromo.phoneImage)} alt="App Preview" />
        </div>

      </div>
    </section>
  );
}